import { Alert, Button, Space } from "antd";
import type { CommunicationSetupIssue } from "./communicationSetupChecks";

type CommunicationSetupAlertProps = {
  issues: CommunicationSetupIssue[];
  onNavigate: (section: string) => void;
  style?: React.CSSProperties;
};

const CommunicationSetupAlert: React.FC<CommunicationSetupAlertProps> = ({
  issues,
  onNavigate,
  style,
}) => {
  if (issues.length === 0) {
    return null;
  }

  const uniqueActions = issues.reduce<CommunicationSetupIssue[]>(
    (acc, issue) => {
      if (!acc.some((item) => item.section === issue.section)) {
        acc.push(issue);
      }
      return acc;
    },
    []
  );

  return (
    <Alert
      type="warning"
      showIcon
      style={{ marginTop: 24, marginBottom: 16, ...style }}
      message="Communication setup incomplete"
      description={
        <ul style={{ margin: "8px 0 0", paddingLeft: 20 }}>
          {issues.map((issue) => (
            <li key={issue.id}>{issue.message}</li>
          ))}
        </ul>
      }
      action={
        <Space wrap>
          {uniqueActions.map((issue) => (
            <Button
              key={issue.section}
              size="small"
              onClick={() => onNavigate(issue.section)}
            >
              {issue.buttonLabel}
            </Button>
          ))}
        </Space>
      }
    />
  );
};

export default CommunicationSetupAlert;
